import styled from 'styled-components';
import { Colors } from '../../../theme';
import { breakpointLG } from '../styles/breakpoints';
import { button } from '../styles/fonts';
import { StyledLinkV2 } from '../styles/ui';
export const Wrapper = styled.div `
  display: none;

  @media (min-width: ${breakpointLG}) {
    display: flex;
  }
`;
export const CustomLink = styled(StyledLinkV2) `
  box-sizing: border-box;
  display: flex;
  align-items: center;
  background-color: transparent;
  border: 2px solid ${Colors.blue300};
  border-radius: 12px;
  padding: 8px;
  height: 48px;
  min-width: 76px;
  max-width: 300px;
  ${button}

  &:hover {
    color: ${Colors.grey900};
    background-color: ${Colors.blue400};
    border: 2px solid ${Colors.blue400};
  }

  &.MuiLink-root {
    &:focus,
    &:active {
      color: ${Colors.grey900};
      background-color: ${Colors.blue300};
      border: 2px solid ${Colors.blue300};
      outline: 2px solid ${Colors.white};
      outline-offset: -4px;
    }
  }
`;
export const RegistrationLink = styled(StyledLinkV2) `
  box-sizing: border-box;
  display: flex;
  align-items: center;
  border: 2px solid ${Colors.blue300};
  background-color: ${Colors.blue300};
  margin-left: 12px !important;
  border-radius: 12px;
  padding: 8px;
  height: 48px;
  min-width: 76px;
  max-width: 300px;
  ${button}

  &:hover {
    background-color: ${Colors.blue400};
    border: 2px solid ${Colors.blue400};
  }

  &.MuiLink-root {
    &:focus,
    &:active {
      color: ${Colors.grey900};
      border: 2px solid ${Colors.blue300};
      outline: 2px solid ${Colors.white};
      outline-offset: -4px;
    }
  }
`;
//# sourceMappingURL=styles.js.map